import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';

@Component({
    selector: 't4-DatePickerDialog',
    templateUrl: 'DatePickerDialog.html',
})
export class DatePickerDialog {
    public selectedDate: moment.Moment = moment();
    public minDate: moment.Moment = moment().add(-10, 'years');
    public maxDate: moment.Moment = moment().add(10, 'years');

    constructor(public dialogRef: MatDialogRef<DatePickerDialog >, @Inject(MAT_DIALOG_DATA) public data:any) {
        //super("DatePickerDialog");

        if (data.selectedDate) this.selectedDate = data.selectedDate;
        if (data.minDate) this.minDate = data.minDate;
        if (data.maxDate) this.maxDate = data.maxDate;
    }

    public close(pin: string) {
        this.dialogRef.close(this.selectedDate);
    }
}
